import { useEffect } from "react";

export default function Toast({ message, onClose }: { message: string; onClose: () => void }) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, 2600);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  return (
    <div className="fixed bottom-6 left-1/2 z-[70] -translate-x-1/2 animate-fade-up">
      <div className="flex items-center gap-2 rounded-lg bg-foreground-950 px-4 py-3 text-sm text-background-50 shadow-lg">
        <span className="flex h-4 w-4 items-center justify-center text-primary-400">
          <i className="ri-checkbox-circle-fill"></i>
        </span>
        {message}
      </div>
    </div>
  );
}